<div class="p-4 flex flex-col gap-3" *transloco="let t; read 'customer.offer_requests';">

  <!--  t(customer.offer_requests.project_name,customer.offer_requests.investor_name,customer.offer_requests.eligible_for_grid_connection)  -->
  <!-- t(customer.offer_requests.optimal_power_less_than_connected_power,customer.offer_requests.loan_financing_for_solar_plant_desired) -->
  <!--  t(customer.offer_requests.conceptual_project_needed, customer.offer_requests.email, customer.offer_requests.mobilePhone)-->
  <ngx-datatable
    [messages]="{emptyMessage: 'no_data_in_table' | transloco}"
    class="material"
    columnMode="flex"
    [loadingIndicator]="loading"
    [rows]="offerRequests"
    [rowHeight]="50"
    [headerHeight]="50">
    <ng-container
      *ngFor="let column of columns">
      <ngx-datatable-column
        *ngIf="!column.type"
        [pipe]="fillIfEmptyValuePipe"
        [flexGrow]="column.flexGrow"
        [name]="t(column.translationKey)"
        [prop]="column.prop">
      </ngx-datatable-column>
      <ngx-datatable-column
        *ngIf="column.type === 'bool'"
        [flexGrow]="column.flexGrow"
        [name]="t(column.translationKey)"
        [prop]="column.prop">
        <ng-template let-value="value" ngx-datatable-cell-template>
          {{value ? t('yes') : t('no') }}
        </ng-template>
      </ngx-datatable-column>
    </ng-container>

    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('analysis')"
      prop="analysisId">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <a [routerLink]="['../power-plant', value]">
          <psc-button
            size="tiny"
            [label]="t('open_analysis')"></psc-button>
        </a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('offer_amount')"
      prop="offerAmount">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        {{(value | number:'1.0-2') || '-'}} {{value ? row.currency : ''}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="2"
      [name]="t('offer_status')"
      prop="offerStatus">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <!-- t(customer.offer_requests.CANCELLED, customer.offer_requests.WAITING, customer.offer_requests.OFFER, customer.offer_requests.DONE, customer.offer_requests.CANCELLED) -->
        {{t(value)}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="1"
      name=""
      prop="analysisId">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <mat-icon
          [matTooltip]="t('edit')"
          matTooltipPosition="above"
          (click)="editOfferRequest(row)"
          class="text-color-blue1 cursor-pointer hover:opacity-60">edit
        </mat-icon>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>

  <psc-dialog
    *ngIf="showOfferEditDialog"
    [title]="selectedOffer.projectName"
    (closeClicked)="showOfferEditDialog = false">
    <psc-edit-offer-request
      (offerSaved)="offerChanged()"
      [offerRequest]="selectedOffer"></psc-edit-offer-request>
  </psc-dialog>
</div>
